import script from "./PackageManagement.vue?vue&type=script&lang=ts&setup=true"
export * from "./PackageManagement.vue?vue&type=script&lang=ts&setup=true"

import "./PackageManagement.vue?vue&type=style&index=0&id=c91f7128&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c91f7128"]])

export default __exports__